import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { NavigationService } from './navigationService';

export interface NavigateToStorefrontParams {
  domainName: string;
  isMobileFlow?: boolean;
  referralAdditionalInfo: string;
}

export const navigateToSplitPageStorefront = ({
  domainName,
  isMobileFlow = false,
  referralAdditionalInfo,
}: NavigateToStorefrontParams) => {
  const { i18n } = getPremiumEssentialsSafe() ?? {};
  const locale = i18n?.language ?? 'en';

  const storefrontUrl = NavigationService.splitPageStorefront({
    domainName,
    isMobileFlow,
    locale,
    shownPrices: true,
    referralAdditionalInfo,
    referrer: referralAdditionalInfo,
  });

  window.open(storefrontUrl, '_self');
};
